/* eslint-disable @typescript-eslint/no-explicit-any */

import type { TriageDensity } from '../../hooks/useTriageDensity';
import type { EmailThreadMetadata, LabelCategoryMapping, TriageCategory } from '../../types/email';
import { TriageThreadCard } from './TriageThreadCard';
import { TriageThreadRow } from './TriageThreadRow';

export interface TriageThreadItemProps {
  thread: EmailThreadMetadata;
  density?: TriageDensity;
  labelMap?: Record<string, string>;
  mappings?: LabelCategoryMapping[];
  categories?: TriageCategory[];
  workspaceMembers?: Array<{ id: number; email: string; fullName: string | null }>;
  onArchive?: (threadId: string) => void;
  onDelegate?: (threadId: string) => void;
  onCreateTask?: (threadId: string) => void;
  onTaskClick?: (taskId: number) => void;
  onCardClick?: (threadId: string) => void;
  /** Re-run analysis for one thread; shown only when the failure is retryable. */
  onRetryAnalysis?: (threadId: string) => void;
  isReadOnly?: boolean;
}

/**
 * Renders one triage thread at the caller's density. Both are hairline rows — the
 * design system has no card list — so this is a choice between a roomy row that shows
 * the analysis and a single line that shows the subject. Keeps the density choice
 * in one place instead of repeating it in each of the three Triage views.
 */
export function TriageThreadItem({ density = 'comfortable', ...props }: TriageThreadItemProps) {
  return density === 'dense' ? <TriageThreadRow {...props} /> : <TriageThreadCard {...props} />;
}

/** Spacing for a list of `TriageThreadItem`s — dense rows self-separate with a border. */
export function triageListClassName(_density: TriageDensity = 'comfortable') {
  return 'space-y-0';
}
